export const SITE_URL = 'https://www.mynurvo.app';
export const APP_STORE_URL = 'https://apps.apple.com/gb/app/id6796389133';

export const siteUrl = (path = '/') => new URL(path, `${SITE_URL}/`).toString();
